<template>
  <router-link
    :to="{ name: 'Challenge Detail', params: { id: item.id, challenge: item } }"
    class="reset-style"
  >
    <div class="challenge-card">
      <h3>{{ item.title }}</h3>
      <small
        ><time>{{
          moment(item.datetime.toDate()).format("DD-MM-YYYY hh:mm:ss A")
        }}</time></small
      >
    </div>
  </router-link>
</template>

<script>
import moment from "moment";
export default {
  props: ["item"],
  methods: {
    moment,
  },
};
</script>

<style scoped>
.challenge-card {
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  margin-top: 8px;
  cursor: pointer;
  padding: 8px;
}
.challenge-card:hover {
  background: rgba(0, 0, 0, 0.05);
}
.reset-style {
  text-decoration: none;
  color: #2f2f2f;
}
</style>